import { render, staticRenderFns } from "./results.vue?vue&type=template&id=6b0f71df&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=6b0f71df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f71df",
  null
  
)

export default component.exports